import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Small404 } from "../../../constant/imagePath";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Button } from "../../../stories/Button/Button";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader";
import classes from "./PageNotFoundMobile.module.css";

export default function PageNotFoundMobile() {
  const history = useHistory();
  return (
    <div
      className={classes.pageNotFoundMobile}
      style={{ background: Colors.mainShadeOfSolitude }}
    >
      <Container fluid className={` ${classes.container}`}>
        <MobileHeader
          isLogo={true}
          isAvatar={true}
          customStyle={{ padding: "0px" }}
        />
        <Row className="g-0">
          <Col md={12}>
            <div className={classes.img404}>
              <img src={Small404} />
            </div>
          </Col>
          <Col md={12}>
            <div className={classes.contentCenter}>
              <h3
                style={{
                  ...Fonts.h3,
                  fontSize: "24px",
                  lineHeight: "32px",
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Looks like you are lost
              </h3>
              <p style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>
                The page you are looking for does not exist.
              </p>
              <Button
                label={"Back to homepage"}
                size={"Large"}
                customStyle={{ marginTop: "32px", height: "56px" }}
                onClick={() => history.push("/")}
                primary={true}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
